import MobileBanner from "@/components/common/MobileBanner";
import CommonButton from "@/components/utils/CommonButton";
import { LazoLogoWhite } from "@/components/utils/LazoLogo";
import { Colors } from "@/enums/Colors";
import { Box, styled } from "@mui/system";
import { ReactNode } from "react";

const RootContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  width: "100vw",
  backgroundColor: Colors.LIGHT_GRAY_BG_F6F8FA,
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "26.75rem",
  borderRadius: "1rem",
  flexDirection: "column",
  gap: "2rem",
  backgroundColor: "#fff",
  boxShadow: "0px 0px 1.7rem 0px rgba(0, 0, 0, 0.07)",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    paddingTop: "5.438rem",
    boxShadow: "none",
  },
}));

const LazoBanner = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "1.563rem",
  padding: "2.5rem 0",
  background: "linear-gradient(285deg, #A16DFC 21.6%, #A146E9 98.56%)",
  borderRadius: "1rem 1rem 0 0",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.75rem",
  padding: "0 2rem 2rem 2rem",
  ".link": {
    fontSize: "0.75rem",
    fontWeight: "500",
    color: Colors.BLACK_151517,
    ":hover": {
      cursor: "pointer",
      color: Colors.LAZO_PURPLE,
    },
  },
  [theme.breakpoints.down("lg")]: {
    position: "absolute",
    boxSizing: "border-box",
    bottom: 0,
    padding: "1rem 2rem 2rem 2rem",
    borderTop: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
    width: "100%",
  },
}));

export const ForgottenPasswordActionButton = styled(CommonButton)(() => ({
  height: "3.313rem",
  width: "100%",
  borderRadius: "0.5rem",
}));

function ForgottenPasswordLayout({ content, actions }: { content: ReactNode; actions: ReactNode }) {
  return (
    <>
      <MobileBanner containerProps={{ sx: { padding: "1rem 0" } }} logoSx={{ width: "6.313rem" }} />
      <RootContainer>
        <ContentContainer>
          <LazoBanner>
            <LazoLogoWhite sxClass={{ width: "6.313rem" }} />
          </LazoBanner>
          {content}
          <ActionsContainer>{actions}</ActionsContainer>
        </ContentContainer>
      </RootContainer>
    </>
  );
}

export default ForgottenPasswordLayout;
